const link = "https://eticketconnect.onrender.com";
// const link = "http://localhost:8000";

export default link;